var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3C16.25 2.7298 16.3953 2.48048 16.6305 2.34735C16.8656 2.21422 17.1542 2.21786 17.3859 2.35688L22.3859 5.35688C22.6118 5.49242 22.75 5.73655 22.75 6C22.75 6.26345 22.6118 6.50758 22.3859 6.64312L17.3859 9.64312C17.1542 9.78214 16.8656 9.78578 16.6305 9.65265C16.3953 9.51952 16.25 9.2702 16.25 9V6.75H5C3.75736 6.75 2.75 7.75736 2.75 9V15C2.75 16.2426 3.75736 17.25 5 17.25H17C17.4142 17.25 17.75 17.5858 17.75 18C17.75 18.4142 17.4142 18.75 17 18.75H5C2.92893 18.75 1.25 17.0711 1.25 15V9C1.25 6.92893 2.92893 5.25 5 5.25H16.25V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoAlt);
export default __webpack_public_path__ + "static/media/redo-alt.89b6d806560232b759778b2b02e4c7da.svg";
export { ForwardRef as ReactComponent };